function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.62 0L0 .62l3.5 3.5L7 .62 6.38 0 3.5 2.88.62 0z",
  fill: "#337DF6"
});

function SvgDownChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 5,
    fill: "none"
  }, props), _ref);
}

export default __webpack_public_path__ + "29ecffeb0b1a3f87c23bf3483ab4681e.svg";
export { SvgDownChevron as ReactComponent };